import immutable from 'immutable'
import _ from 'lodash'
import Guid from 'guid'

import {CHAT_SEND} from './chat.action'
import {CHAT_RECV, CHAT_LOAD} from '../socket/socket.action'
import chatSocket from '../socket/socket.chat'
import {HashTag} from '../services/hashtag'


export default (state, action) => {
    switch (action.type) {
        case CHAT_SEND:      

            let outgoingMessage = {
                'temporary_id': Guid.raw(),
                'message_id': null,
                'trip_guid': action.trip_id,
                'message': action.message,
                'message_type': 'CHAT',
                'sender_guid': action.sender_user_id,
                'is_private': true,
                'hashtag': action.hashtag,
                'mentions': action.mentions,
                // 'created_at': new Date(action.created_at).toString()
                'created_at': action.created_at.format()
            }
            chatSocket.send(outgoingMessage)
            return state.push(immutable.fromJS(outgoingMessage))
        case CHAT_LOAD:
        case CHAT_RECV:
            // if there is a temp id, find the relevant chat in state and update id
            // because temp id will always be there, we need to see if we can find it
            let targetMessageIdx = -1
            if (action.data.temporary_id) {
                targetMessageIdx = state.findIndex((message) => {
                    return message.get('temporary_id') === action.data.temporary_id
                })
            }

            if (targetMessageIdx >= 0 && action.data.temporary_id != null) {
                return state.update(targetMessageIdx, (chatMessage) => {
                    return chatMessage.merge({
                        message_id: action.data.message_id,
                        // temporary_id: null
                    })
                })
            } else {
                let tHash = action.data.hashtag
                if (typeof tHash === 'string') {          
                    tHash = JSON.parse(action.data.hashtag)
                }    

                let tMentions = action.data.mentions
                if (typeof tMentions === 'string') {          
                    tMentions = JSON.parse(action.data.mentions)
                }

                let incomingMessage = {
                    'temporary_id': action.data.temporary_id,
                    'message_id': action.data.message_id,
                    'trip_id': action.data.trip_id,
                    'message': action.data.message,
                    'sender_user_id': action.data.sender_user_id,
                    'sender_guid': action.data.sender_guid,
                    'hashtag': tHash,
                    'mentions': tMentions,
                    'created_at': action.data.created_at
                }

                return state.push(immutable.fromJS(incomingMessage))
            }
        default:
            return state
    }
}
